import { createBrowserHistory } from 'history';
import { createStore, combineReducers, compose } from 'redux';

import * as reducers from './reducers';
// redux
const reduxCombineReducers: any = combineReducers; //tslint:disable-line
const reducer = reduxCombineReducers({
    authState: reducers.authReducer,
    menuState: reducers.menuReducer,
    merchantState: reducers.merchantReducer,
});

class RWindow extends Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose | undefined;
}

const rwindow = window as unknown as RWindow;
//const composeEnhancers = rwindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const history = createBrowserHistory();

const store = createStore(
    reducer,
);
export * from './actions'
export * from './state';
export {
    store,
    history
};





